'use client';

var setCookie = function (name, value, days, domain) {
    if (domain === void 0) { domain = ''; }
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    var domainStr = '';
    if (domain !== '') {
        domainStr = 'domain=' + domain + '; ';
    }
    document.cookie = name + '=' + value + expires + '; ' + domainStr + 'path=/';
};
var getCookie = function (name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
};

export { getCookie, setCookie };
//# sourceMappingURL=cookie.js.map
